
export default {
  root: {
    minHeight: 'auto'
  },
  indicator: {
    display: 'none'
  },
};
